/* global window appData */

import Vue from 'vue';
import { mapState } from 'vuex';
import $, { parseJSON } from 'jquery';

function doRequest(endpoint, data) {
	return $.ajax({
		method: 'post',
		data: data,
		url: `${appData.root}${endpoint}`,
		headers: { 'X-WP-Nonce': appData.nonce }
	});
}


// Mixins
import { RestComponent } from '../../../mixins/rest-component';
import { CaseListing } from '../../../mixins/case-listing';

// Template and media files
import template from '../shared-template/page-listing-overview.vhtml';
import logo from '../../../../_img/logo-esbjerghavn.svg';
import logoAscanius from '../../../../_img/logo.svg';
import arrowBtn from '../../../../_img/icons/arrow-btn.svg';
import Userbar from '../../userbar/userbar'


export const PagePrivateListingOverview = Vue.component('page-private-listing-overview', {
	components: {
		logo,
		arrowBtn,
		logoAscanius,
		Userbar
	},
	mixins: [RestComponent, CaseListing],
	template: template,
	props: {
		appLoaded: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		containerWidth: 0,
		hideMoreThan300: false,
		hideMoreThan500: false,
		hideLogo: false,
		isLoggedIn: appData.user.isLoggedIn,
		eulaRegistering: false,
		mailingList: false,
		userCreate: false,
		showValueChains: false,
		valuechain: '',
		eulas: (localStorage.getItem('eulas')) ? JSON.parse(localStorage.getItem('eulas')) : {},
		options: [
			{
				value: "deadline",
				label: "Sort by deadline"
			},
			{
				value: "title",
				label: "Sort by name"
			},
			{
				value: "created",
				label: "Sort by created"
			}
		]
	}),
	computed: {
		website: vm => vm.$store.state.appsData.data.website,
		...mapState({
			website: state => state.appsData.data.website,
			showLogo: state => state.content.showLogo,
			isNavigating: state => state.pages.isNavigating,
		}),
		showeula: function () {
			if (!Object.keys(this.eulas).length) {
				return true;
			}

			if (!this.eulas['eula-' + this.content.eulaID]) {
				return true;
			}

			if (this.eulas['eula-' + this.content.eulaID]) {
				let expire = new Date(this.eulas['eula-' + this.content.eulaID])
				let now = new Date();

				if (expire < now) {
					return true
				}
			}

			return false;
		},
		reduce: function () {
			return label => label.value
		}
	},
	watch: {
		content() {
			this.$store.commit('sidebar/updateData', {
				name: 'parent',
				value: this.content.parent,
			});
		}
	},
	created() {
		this.$store.dispatch('pages/setScrollPosition');
		this.$store.dispatch('pagination/makeFullScreen');
		this.$store.commit('pagination/updateData', {
			name: 'outOfViewPos',
			value: '',
		});
		this.$store.commit('pagination/updateData', {
			name: 'fullWidthUntilLg',
			value: true,
		});
		this.$store.commit('pagination/updateData', {
			name: 'fullWidthUntilLg',
			value: true,
		});
	},
	mounted() {
	},
	beforeDestroy() {
	},
	methods: {
		toogleScrollElements(e) {
			e.target.scrollTop > 50 ? this.hideLogo = true : this.hideLogo = false;
		},
		acceptEula() {
			this.eulaRegistering = true
			let data = {
				listingId: this.content.eulaID,
				userId: appData.user.id,
			}

			doRequest('kla/v1/user/accept_eula', data)
				.done(data => {
					this.eulaRegistering = false

					if (data.registered) {
						let expire = new Date()
						expire.setDate(expire.getDate() + 90);
						let dd = String(expire.getDate()).padStart(2, '0');
						let mm = String(expire.getMonth() + 1).padStart(2, '0'); //January is 0!
						let yyyy = expire.getFullYear();
						let eulaID = 'eula-' + this.content.eulaID

						this.$set(this.eulas, eulaID, yyyy + '-' + mm + '-' + dd)
						localStorage.setItem('eulas', JSON.stringify(this.eulas))
					}

				})
				.fail(data => {
					this.eulaRegistering = false
				});

		},
		navigateToIndex(link, privacy) {
			if (!this.isLoggedIn && privacy === 'private') {
				link = '/log-in'
			}

			window.removeEventListener('scroll', this.$options.throttleFunction);
			this.$store.commit('sidebar/updateData', {
				name: 'transparentUntilLg',
				value: false,
			});
			this.$store.commit('sidebar/updateData', {
				name: 'stuckToTopMobile',
				value: false,
			});
			this.navigateLeft(link);
			setTimeout(() => {
				this.$store.commit('sidebar/updateData', {
					name: 'sidebarPos',
					value: 'left',
				});
			}, 100);
		},
	}
});



// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-private-listing-overview/page-private-listing-overview.js